(ns com.theplantscape.web-ui.tailwind.banner
  (:require 
   [com.theplantscape.web-ui.tailwind.images :refer [picture]]
   [com.theplantscape.web-ui.tailwind.buttons :refer [ui-btn-link]]))


(defn hero-banner [{:keys [title description buttons]}]
  [:header
   [:div.container.grid.md:grid-cols-2.gap-4.items-center
    [:div.grid.items-center.gap-8.lg:grid-cols-2
     [:h1 title]
     [:p description]
     (into [:div] (mapv (fn [button]
                          [ui-btn-link button]
                          ) buttons))]
    [:div.h-96
     [picture {:image "https://img.theplantscape.com/api/image/do/404-image-01.jpg?p=h-192"}]]]])

;; https://simple.cruip.com/

(defn text-button-banner
  ([header description buttons] (text-button-banner header nil description buttons))
  ([header word description buttons]
   [:div.text-center.mb-16;.pb-12.md:pb-16
    [:h1.text-5xl.md:text-6xl.font-extrabold.leading-tighter.tracking-tighter.mb-4.aos-init.aos-animate
     {:data-aos "zoom-y-out"}
     header
     (when word
       [:span.bg-clip-text.text-transparent.bg-gradient-to-r.from-blue-500.to-teal-400 "wonderful"])]
    [:div.mx-auto
     [:p.text-xl.text-gray-600.mb-8.aos-init.aos-animate
      {:data-aos "zoom-y-out" :data-aos-delay "150"}
      description]
     (when buttons
       (into [:div.max-w-xs.mx-auto.sm:max-w-none.sm:flex.sm:justify-center.aos-init.aos-animate
              {:data-aos "zoom-y-out" :data-aos-delay "300"}]
             (mapv ui-btn-link buttons)))]]))
